import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  IconButton,
  useTheme
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  text: string;
  imageSrc?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
}

const InfoDialog: React.FC<Props> = ({
  open,
  onClose,
  title,
  text,
  imageSrc,
  maxWidth = "md"
}) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogContent
        sx={{
          position: "relative",
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>

        {text.split("\n").map((line, index) => (
        <Typography variant="body1" key={index}>
          {line}
        </Typography>
        ))}

        {imageSrc && (
          <Box display="flex" justifyContent="center" mt={2}>
            <img
              src={imageSrc}
              alt="Bild nicht gefunden"
              style={{ maxWidth: "100%", borderRadius: 8 }}
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default InfoDialog;
